<template>
  <div class="opList">
    <el-form :inline="true" :model="opNumForm" ref="opNumForm" :rules="rules" class="demo-form-inline">
      <h1>OP Listing</h1>
      <el-form-item prop="option">
        <el-cascader v-model="opNumForm.option" :options="options" ref="eventCascader" @change="elCascaderOnlick"
                     :show-all-levels="false" placeholder="Select Search Type"></el-cascader>
      </el-form-item>
      <el-form-item prop="number">
        <el-input v-model="opNumForm.number" @keyup.enter.native="onSubmit"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" plain @click="onSubmit" :loading="searching">Search</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="opData" v-show="showOpRecord || searching" v-loading="searching" empty-text="No Record Found" style="width: 100%"
              :cell-style="{textAlign: 'center'}"
              :header-cell-style="{textAlign: 'center', background: '#E5E7E9'}">
      <el-table-column prop="op_lan_ip" label="OP LAN IP Address"></el-table-column>
      <el-table-column prop="op_wan_ip" label="OP WAN IP Address"></el-table-column>
      <el-table-column prop="er_num" label="ER Number" :formatter="arrayFormat"></el-table-column>
      <el-table-column prop="active_status" label="OP Status"></el-table-column>
      <el-table-column prop="outer_license_id" label="Outer License ID"></el-table-column>
      <el-table-column prop="last_updated" label="Last Updated [as UTC(+00:00)]" :formatter="dateFormat"></el-table-column>
    </el-table>

  </div>
</template>

<script>
import {getOpList, searchOpList} from '../api'
import moment from 'moment'
export default {
  name: 'OpList',
  data () {
    return {
      searching: false,
      showOpRecord: false,
      search_type: 'license_id',
      opData: [],
      opNumForm: {
        number: '',
        option: ''
      },
      rules: {
        number: [
          { required: true, message: 'Enter Search Query', trigger: 'blur' }
        ],
        option: [
          { type: 'array', required: true, message: 'Please Select a Search Type', trigger: 'blur' }
        ]
      },
      options: [{
        value: 'license_id',
        label: 'License ID (Outer)'
      }, {
        value: 'er_num',
        label: 'ER Number'
      }],
      eventCascader: null
    }
  },
  created: function () {
    this.getDataList()
  },
  methods: {
    getDataList () {
      let that = this
      that.searching = true
      getOpList().then(data => {
        console.log('getOpList Success -> data.data')
        console.log(data.data)

        that.opData = data.data.license_record
        that.showOpRecord = true
        that.searching = false
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        that.showOpRecord = false
        that.searching = false
      })
    },
    onSubmit () {
      let that = this
      that.$refs.opNumForm.validate((valid) => {
        if (valid) {
          that.searching = true
          searchOpList(that.search_type, that.opNumForm.number).then(data => {
            that.searching = false
            that.opData = data.license_record

            console.log('searchOpList Success -> data')
            console.log(data)
          }).catch(error => {
            if (error) {
              console.log(error.stack)
            }
            that.searching = false
          })
        } else {
          console.log('error searching!!')
          return false
        }
      })
    },
    elCascaderOnlick (value) {
      let that = this

      console.log('elCascaderOnlick - value = ', value)
      console.log(that.$refs['eventCascader'].getCheckedNodes()[0].label)
      console.log(that.$refs['eventCascader'].getCheckedNodes()[0].value)

      that.search_type = value[0]
    },
    // Format Timestamps
    dateFormat: function (row, column) {
      let date = row[column.property]
      if (date === -1) {
        return 'No Limit'
      }
      if (date === undefined) {
        return ''
      }
      return moment.utc(date).format('YYYY-MMM-DD HH:mm:ss', true)
    },
    arrayFormat: function (row, column) {
      var arrayInput = row[column.property]
      if (arrayInput === undefined) {
        return ''
      }
      if (Array.isArray(arrayInput)) {
        return arrayInput.join()
      } else {
        return arrayInput
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .generate{
    margin: 0px auto;
    position: relative;
    margin-top: 50px;
  }
</style>

<style>
.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// OpList.vue?3ebd1b26